import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { Title } = Typography;

export const UIModal = ({
  open,
  onClose,
  children,
  size = "md",
  header = null,
  footer = null,
  closeButton = true,
  width,
  customHeight,
}) => {
  // Responsive width logic
  const getResponsiveWidth = () => {
    if (typeof size === "string") {
      switch (size) {
        case "sm":
          return 400;
        case "md":
          return 550;
        case "lg":
          return 800;
        default:
          return size;
      }
    }
    return width || 550;
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      footer={null}
      width="90%" // Default for mobile (will adjust below)
      style={{
        maxWidth: getResponsiveWidth(),
        padding: "0 10px",
      }}
      bodyStyle={{
        padding: 0,
      }}
      destroyOnClose
      maskClosable={true}
    >
      <div
        style={{
          maxHeight: customHeight || "80vh",
          overflowY: "auto",
          position: "relative",
          padding: "0 16px 16px",
        }}
      >
        {closeButton && (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            style={{
              position: "absolute",
              top: 8,
              right: 15,
              zIndex: 10,
            }}
          />
        )}

        {header && (
          <>
            <div style={{ marginTop: "8px", paddingTop: "10px" }}>
              <Title
                level={4}
                style={{
                  fontSize: "20px",
                  fontWeight: 500,
                  wordBreak: "break-word",
                  marginBottom: 0,
                }}
              >
                {header}
              </Title>
            </div>
            <Divider style={{ margin: "10px 0" }} />
          </>
        )}

        <div>{children}</div>

        {footer && (
          <>
            <Divider style={{ margin: "15px 0 10px" }} />
            <div>{footer}</div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default UIModal;
